import { ApiError, isUserFacing, request } from '@/shared/api/client';
import type { BannerDto } from '@/shared/lib/banner';
import { toExchangeResult } from '@/shared/lib/exchange-result';
import type { ExchangeResult } from './exchange';

type ProductDto = { code: string; name: string; brandName: string; imageUrl: string };

type CouponExchangeStatusResponseDto = {
  status: 'EXCHANGEABLE' | 'USED' | 'CHANGED' | 'CANCELED' | 'EXPIRED';
  products?: ProductDto[];
  changedToken?: string | null;
  productName: string;
  clientName: string;
  banners?: BannerDto[];
};

export async function list(seqnumber: string): Promise<ExchangeResult> {
  try {
    const dto = await request<CouponExchangeStatusResponseDto>(`/coupons/${encodeURIComponent(seqnumber)}/products`);
    return toExchangeResult(dto, seqnumber);
  } catch (error) {
    if (error instanceof ApiError && error.status >= 400) {
      const show = isUserFacing(error);
      return { status: 'error', message: show ? error.message : '', show };
    }
    throw error;
  }
}

export async function change(
  seqnumber: string,
  subcode: string,
): Promise<{ success: boolean; message: string; seqnumber?: string }> {
  try {
    await request<void>('/exchanges', { method: 'POST', body: { token: seqnumber, productCode: subcode } });
  } catch (error) {
    if (error instanceof ApiError && error.status >= 400) {
      return { success: false, message: isUserFacing(error) ? error.message : '잠시후 다시 시도해주세요.' };
    }
    throw error;
  }

  const result = await list(seqnumber);
  if (result.status === 'changed') {
    return { success: true, message: '교환이 완료되었습니다.', seqnumber: result.seqnumber };
  }
  return { success: false, message: '교환 결과를 확인하지 못했어요. 잠시 후 기존 링크로 다시 접속해주세요.' };
}
